import VendorErrorEntity from "../entities/VendorError.Entity";

export default class VendorResponseDataModel {
    vendorResponse: Array<VendorErrorEntity>;
    public constructor (vendorResponse:Array<VendorErrorEntity>){
        this.vendorResponse = vendorResponse;
    }
}
